

















































































































import { Component, Vue } from 'nuxt-property-decorator';
import {
  WAR_ROOM_POSTS_TAB_MYFEED_PAGE,
  ACADEMY_All_ARTICLES_PAGE,
  JOBS_WELCOME_PAGE,
  JOBS_CANDIDATE_PROFILE_PAGE,
  ABOUT_US_PAGE,
  CAREERS_PAGE,
  SALES_COMPENSATION_2022_PAGE,
} from '@/constants';
import OrganizationJsonLd from './OrganizationJsonLd.vue';
import { LINK_TO_MOBILE_APP } from '~/constants/common';

@Component({
  name: 'Footer',
  components: {
    SocialIconsBar: () => import('@/components/common/SocialIconsBar/SocialIconsBar.vue'),
    TrustPilotBadge: () => import('@/components/global/Badges/TrustPilotBadge.vue'),
    OrganizationJsonLd,
  },
  methods: {
    // We use button instead of link for a SEO reason - google will follow the link otherwise and spends a crawl budget
    openContactUs() {
      this.$modal.showWithRoute('CONTACT_US_MODAL');
    },

    handleOpenCookieSettings() {
      // https://community.cookiepro.com/s/article/UUID-d8291f61-aa31-813a-ef16-3f6dec73d643?language=en_US
      try {
        // @ts-ignore
        window?.OneTrust?.ToggleInfoDisplay();
      } catch (e) {
        console.error(e);
      }
    },
  },
})
export default class Footer extends Vue {
  readonly currentYear = new Date().getFullYear();
  readonly linkToMobileApp = LINK_TO_MOBILE_APP;
  readonly warRoomPage = WAR_ROOM_POSTS_TAB_MYFEED_PAGE;
  readonly academyPage = ACADEMY_All_ARTICLES_PAGE;
  readonly jobsPage = this.$auth.loggedIn ? JOBS_CANDIDATE_PROFILE_PAGE : JOBS_WELCOME_PAGE;
  readonly aboutUsPage = ABOUT_US_PAGE;
  readonly careersPage = CAREERS_PAGE;
  readonly salariesPage = SALES_COMPENSATION_2022_PAGE;
}
